export default class TextSlider {
    
    toggleActive() {

        var loop = setInterval(start,5000);
        function start() {

            var active = $('.textslider__item.active .text-reveal');
            var deactive = $('.textslider__item:not(.active) .text-reveal');
            var tag_active = $('.tagslider__item.active .text-reveal');
            var tag_deactive = $('.tagslider__item:not(.active) .text-reveal');

            $('.textslider__item').toggleClass('active');
            $('.tagslider__item').toggleClass('active');

            deactive.each(function( index ) {
                $(this).addClass('active');
            });

            tag_deactive.addClass('active');


            setTimeout(function(){
                active.each(function( index ) {
                    $(this).removeClass('active');
                    tag_active.removeClass('active');
                });
            }, 300);

        }

    }


  
    init() {
        document.querySelector('.textslider') ? this.toggleActive() : null;
    }
}